import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Landing Page Components
import Header from "./components/landing/Header";
import HeroSection from "./components/landing/HeroSection";
import WhySection from "./components/landing/WhySection";
import HowItWorksSection from "./components/landing/HowItWorksSection";
import IncomeSection from "./components/landing/IncomeSection";
import CropsShowcase from "./components/landing/CropsShowcase";
import FAQSection from "./components/landing/FAQSection";
import Footer from "./components/landing/Footer";
import EnquiryModal from "./components/landing/EnquiryModal";

const LandingPage = () => {
  const [isEnquiryOpen, setIsEnquiryOpen] = useState(false);

  const openEnquiry = () => setIsEnquiryOpen(true);
  const closeEnquiry = () => setIsEnquiryOpen(false);

  return (
    <div className="min-h-screen bg-white">
      <Header onOpenEnquiry={openEnquiry} />
      <main>
        {/* Section Order: Hero (with form) → Why Us → Crops → How It Works → Opportunity → FAQ */}
        <HeroSection />
        <WhySection />
        <CropsShowcase />
        <HowItWorksSection />
        <IncomeSection />
        <FAQSection />
      </main>
      <Footer onOpenEnquiry={openEnquiry} />
      
      {/* Enquiry Popup Modal - Additional way to enquire */}
      <EnquiryModal isOpen={isEnquiryOpen} onClose={closeEnquiry} />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
